export const SET_PROPERTY = 'SET_PROPERTY';
export const SET_SUCCESS = 'SET_SUCCESS';
export const SET_DATA = 'SET_DATA';
export const PLAID_LINK_TOKEN = 'PLAID_LINK_TOKEN';
export const PLAID_ACCESS_TOKEN = 'PLAID_ACCESS_TOKEN';
export const SET_ERR = 'SET_ERR';
export const SET_PAYMENT = 'SET_PAYMENT';
export const SET_COVERAGEAMOUNT = 'SET_COVERAGEAMOUNT';
export const EMAIL_VERIFY = 'EMAIL_VERIFY';
export const TENANT_INFO = 'TENANT_INFO';
export const SET_SHORTFORM_DATA = 'SET_SHORTFORM_DATA';
